import { useQuery } from '@tanstack/react-query'
import { announcementService } from '@/lib/api/services/announcement'
import type { AnnouncementHighlight, ApiResponse } from '@/lib/api/types'

export const announcementKeys = {
  all: ['announcements'] as const,
  highlighted: () => [...announcementKeys.all, 'highlighted'] as const,
}

/**
 * Hook to fetch highlighted announcements
 */
export function useHighlightedAnnouncements() {
  return useQuery<ApiResponse<AnnouncementHighlight>, Error>({
    queryKey: announcementKeys.highlighted(),
    queryFn: () => announcementService.getHighlightedAnnouncements(),
    staleTime: 5 * 60 * 1000,
  })
}
